import { Injectable, OnChanges, SimpleChange } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {Observable, Subject} from "rxjs/Rx"; 
import 'rxjs/add/operator/share';

@Injectable()
export class ProfileDataRecieveService {
    private data:string;

    exist:boolean=false;

    constructor() {
        this.data = localStorage.getItem('profile');
    }

    get(){
        let subjectData: Subject<string> = new Subject<string>();
        
        subjectData.next(this.data);
        setTimeout(() => {
            subjectData.next(this.data);
        }, 1000);
        return subjectData.asObservable();
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/user_data_recieve.service.ts